<template>

  <div class="height-100">
    <MeetMain
      v-if="meetcontext"
      :token="meetcontext.token"
      :transcript="meetcontext.transcript" />

    <creating
      v-if="creating"
      height="100%" />

    <div
      v-if="!creating"
      class="main"
      :class="{ 'adapted-meet-main': !!meetcontext }">

      <main-menu />
      <router-view />

      <notification-observer />
      <task-observer />
      <approval-observer />
      <candidate-observer />
      <alert-modal />
      <warn />
      <accept-terms />

    </div>
  </div>

</template>

<script>
import Bootstrapping from '@/utils/Bootstrapping'
import CandidateQuickSearch from './CandidateQuickSearch/CandidateQuickSearch'
import CandidateObserver from '@/components/Candidate/CandidateObserver'
import NotificationObserver from '@/components/Notification/NotificationObserver'
import TaskObserver from '@/components/Task/TaskObserver'
import ApprovalObserver from '@/components/Approval/ApprovalObserver'
import MainMenu from './MainMenu'
import AlertModal from '@/components/Parts/AlertModal'
import Warn from './Warn/Warn'
import AcceptTerms from './AcceptTerms/AcceptTerms'
import MeetMain from './Meet/MeetMain'

export default {
  name: 'Main',
  components: {
    CandidateQuickSearch,
    CandidateObserver,
    NotificationObserver,
    TaskObserver,
    ApprovalObserver,
    MainMenu,
    AlertModal,
    Warn,
    AcceptTerms,
    MeetMain
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    me () {
      return this.$store.getters.getMe
    },
    account () {
      return this.$store.getters.getAccount
    },
    meetcontext () {
      return this.$store.getters.meetcontext
    }
  },
  created () {
  },
  mounted () {
    Bootstrapping(this).then(() => {
      this.$store.dispatch('socketConnect', this.account._id)
      this.creating = false
      this.$i18n.locale = this.me.locale ? this.me.locale : 'pt-BR'

      // const meetToken = this.$route.query.meet_token
      // if (meetToken) {
      //   this.showMeetMain(meetToken)
      // }
    })
  },
  methods: {
    // showMeetMain (meetToken) {
    //   this.$store.dispatch('setMeetMain', { token: meetToken })
    //   this.$router.beforeEach((to, from, next) => {
    //     if (from.query.hasOwnProperty('meet_token') && !to.query.hasOwnProperty('meet_token')) {
    //       next({
    //         path: to.path,
    //         query: {
    //           ...to.query,
    //           meet_token: from.query.meet_token
    //         }
    //       })
    //     } else {
    //       next()
    //     }
    //   })
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Main.vue